import OfferSelector from '../../form-elements/OfferSelector';
import { useStoreIdSafe } from '../../context';
import { WidgetProps } from '@rjsf/utils';

function OfferSelectorWidget(props: WidgetProps) {
  const storeIdContext = useStoreIdSafe();
  const storeId = storeIdContext?.storeId || (props.options?.storeId as string);

  return <OfferSelector value={props.value} onChange={props.onChange} storeId={storeId} />;
}

export default OfferSelectorWidget;
